var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16663 1.66699C5.02449 1.66699 1.66663 5.02486 1.66663 9.16699C1.66663 13.3091 5.02449 16.667 9.16663 16.667C10.9387 16.667 12.5672 16.0524 13.8507 15.0248L17.1125 18.2913C17.4377 18.617 17.9653 18.6174 18.291 18.2922C18.6167 17.967 18.617 17.4394 18.2918 17.1137L15.0287 13.8458C16.0537 12.5631 16.6666 10.9366 16.6666 9.16699C16.6666 5.02486 13.3088 1.66699 9.16663 1.66699ZM9.16663 3.33366C5.94497 3.33366 3.33329 5.94533 3.33329 9.16699C3.33329 12.3887 5.94497 15.0003 9.16663 15.0003C12.3883 15.0003 15 12.3887 15 9.16699C15 5.94533 12.3883 3.33366 9.16663 3.33366Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.56504967a67f4537a6608c67152855b1.svg";
export { ForwardRef as ReactComponent };